import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionItemPimManualsConverter extends CmsConverterService<AccordionItemPimManualsData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const ACCORDION_ITEM_PIM_MANUALS_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, AccordionItemPimManualsData>>('AccordionItemPimManualsConverter')

export type AccordionItemPimManualsData = ConvertedComponentData
